import React from 'react'
import { reportError } from './crashReporter'

/**
 * Catches React render errors and forwards them to SigNoz.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    reportError(error, {
      source: 'react.error-boundary',
      componentStack: info && info.componentStack,
    })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }
      return null
    }
    return this.props.children
  }
}
